module.exports = __webpack_public_path__ + "static/media/预约.465ce98f.svg";